import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListEmpty from '../../components/fragments/ListEmpty';
import Screen from '../../components/fragments/Screen';
import KanisaActionCard from '../../components/legacy/KanisaActionCard';
import { rtGetListData } from '../../store/slices/listSlice';

export default function BookingScreen() {
    const dispatch = useDispatch();
    const state = useSelector((st) => st);

    const { bookings, busy } = state.list2;

    useEffect(() => {
        dispatch(rtGetListData('bookings', 'bookings'));
    }, [dispatch]);

    return (
        <Screen loading={busy['bookings']} title="Bookings">
            {bookings?.map(
                ({ id, name, time, venue, date, reserved, category }) => {
                    return (
                        <KanisaActionCard
                            key={`${id}`}
                            id={id}
                            name={name}
                            venue={venue}
                            date={date}
                            time={time}
                            num={reserved}
                            bookCategory={category}
                            booking
                        />
                    );
                }
            )}
            {!busy['bookings'] && bookings?.length < 1 && <ListEmpty />}
        </Screen>
    );
}
